/*
 *
 * UsersDetail constants
 *
 */

export const FLUSH_STATE = 'app/UsersDetail/FLUSH_STATE';

export const LOAD_USER = 'app/UsersDetail/LOAD_USER';
export const LOAD_USER_SUCCESS = 'app/UsersDetail/LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'app/UsersDetail/LOAD_USER_ERROR';
